import { call, put, select } from "redux-saga/effects"
import { push } from "connected-react-router"


import api from "apis"

import {
  facebookLogin,
  fetchPointsInfo as fetchPointsInfoAction,
  setPointsInfo,
  doLogout
} from "../actions"

export default function* fetchPointsInfo(action) {
  const state = yield select()
  let url = "/api/v5/user/points_info"

  const result = yield call(api.authGet, url)
  if (result && !result.error) {
    yield put(setPointsInfo(result))
  } else if (
    result &&
    result.error &&
    state.user.facebook &&
    state.user.facebook.status &&
    state.user.facebook.status.status == "connected"
  ) {
    yield put(facebookLogin(fetchPointsInfoAction()))
  } else if (result && result.error) {
    yield put(doLogout())
    yield put(push("/signin"))
  }
}
